module.exports = __webpack_public_path__ + "media/react/payments/pages/add_ons/assets/admissions/headshot_jen-f026f2f7d6f663384fb6a7fcfadb7ab4.jpg";